import { render, staticRenderFns } from "./choosestaff.vue?vue&type=template&id=04c22d48"
import script from "./choosestaff.vue?vue&type=script&lang=js"
export * from "./choosestaff.vue?vue&type=script&lang=js"
import style0 from "./choosestaff.vue?vue&type=style&index=0&id=04c22d48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports